import { useRef } from "react";
import { Link } from "react-router-dom";
import { getLatest } from "@/utils/video-utils";
import { usePlayNotice } from "@/components/feature/PlayNotice";

export default function LatestRow() {
  const list = getLatest();
  const scrollRef = useRef<HTMLDivElement>(null);
  const { showPlayNotice } = usePlayNotice();

  const scrollBy = (dir: number) => {
    if (!scrollRef.current) return;
    scrollRef.current.scrollBy({ left: dir * 320, behavior: "smooth" });
  };

  return (
    <section className="w-full py-10 md:py-14 bg-background-100/50">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="flex items-end justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">最新上线</h2>
            <p className="mt-2 text-sm text-foreground-600">刚刚更新的新鲜内容，第一时间为你送达</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              type="button"
              onClick={() => scrollBy(-1)}
              aria-label="向左滚动"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-950 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-xl"></i>
            </button>
            <button
              type="button"
              onClick={() => scrollBy(1)}
              aria-label="向右滚动"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-background-200 text-foreground-950 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto no-scrollbar px-4 md:px-8 lg:px-12 pb-2"
      >
        {list.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group shrink-0 w-64 md:w-72 rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer"
          >
            <div className="relative w-full aspect-video overflow-hidden bg-background-200">
              <img
                src={video.poster}
                alt={`${video.title} 缩略图`}
                title={`${video.title} - 嫩草视频最新上线`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-background-50/0 group-hover:bg-background-50/40 transition-colors"></div>
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  showPlayNotice(video.title);
                }}
                aria-label={`播放 ${video.title}`}
                className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
                  <i className="ri-play-fill text-2xl"></i>
                </span>
              </button>
              <span className="absolute bottom-2 right-2 bg-background-50/85 text-foreground-950 text-xs px-2 py-0.5 rounded">
                {video.category}
              </span>
            </div>
            <div className="p-3">
              <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-500 transition-colors">
                {video.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-600">上线时间 {video.updateDate}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}